/**
 * Project share-link DTOs.
 *
 * Mirrors Prisma `ProjectShareLink` — a CSPRNG-tokened link to a project's
 * read-only client/designer pack at `/shared/[token]`. Multiple active links
 * per project; `accessCount` is the view tally; `revokedAt` soft-revokes.
 */
import { z } from "zod";

export const ProjectShareLinkSchema = z.object({
  id: z.string(),
  token: z.string(),
  /** Full public URL — `${BASE}/shared/${token}`. */
  url: z.string(),
  label: z.string().nullable(),
  accessCount: z.number(),
  revokedAt: z.string().datetime().nullable(),
  expiresAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type ProjectShareLink = z.infer<typeof ProjectShareLinkSchema>;

// #2411 server-boundary variant: the mobile app parses the permissive base;
// the routes serialise through the Strict form.
export const ProjectShareLinkStrict = ProjectShareLinkSchema.strict();
